import { render, staticRenderFns } from "./RepetitionInput.vue?vue&type=template&id=671a8004&"
import script from "./RepetitionInput.vue?vue&type=script&lang=js&"
export * from "./RepetitionInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports